<template>
  <div class="base-layout">
    <div class="container">
      <header class="layout-header">
        <public-header></public-header>
        <slot name="header"></slot>
      </header>
      <main>
        <slot name="main"></slot>
      </main>
      <footer class="layout-footer">
        <public-footer></public-footer>
      </footer>
    </div>
  </div>
</template>

<script>
import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";
export default {
  components: {
    PublicHeader,
    PublicFooter
  }
};
</script>

<style lang="less" scoped>
@import "../theme.less";

.base-layout {
  .layout-footer {
    min-height: 285px;
    background-color: @layout-footer-bg;
    padding: 0 226px;
  }
}
</style>